import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import dayjs from "dayjs";
import CustomLoader from "../../customLoader/CustomLoader";
import {
  getRequestStatusKey,
  getRequestStatusLabel,
} from "../../../utils/approvalStatus";
import "./MessagesApproval.css";

const formatDate = (value) => {
  if (!value) return "—";
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("MMM DD YYYY, hh:mm A") : value;
};

const DetailRow = ({ label, value }) => (
  <div className="messages-approval-detail-row">
    <span className="messages-approval-detail-label">{label}</span>
    <span className="messages-approval-detail-value">{value || "—"}</span>
  </div>
);

const MessagesApprovalDetailsModal = ({ isOpen, onClose, loading, details }) => {
  const requester = details?.requester || {};
  const approver = details?.approver;

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" className="messages-approval-details-modal">
      <ModalHeader toggle={onClose} className="messages-approval-details-modal__header">
        Message Request Details
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <CustomLoader />
        ) : (
          <div className="messages-approval-details-content">
            <DetailRow label="Request Date" value={formatDate(details?.request_initiate_time)} />
            <DetailRow label="Subject" value={details?.subject} />
            <DetailRow label="Message Body" value={details?.message_body} />
            <DetailRow
              label="Requester"
              value={
                requester?.name
                  ? `${requester.name}${requester.role ? ` (${requester.role})` : ""}`
                  : "—"
              }
            />
            <DetailRow label="Requester Email" value={requester?.email} />
            <DetailRow label="School" value={requester?.school_name} />
            <DetailRow label="College" value={requester?.college_name} />
            <DetailRow label="District" value={requester?.district_name} />
            <DetailRow
              label="Approver"
              value={
                approver?.name ||
                details?.approver_name ||
                "—"
              }
            />
            <DetailRow
              label="Request Status"
              value={
                <span
                  className={`messages-approval-status ${getRequestStatusKey(details)}`}
                >
                  {getRequestStatusLabel(getRequestStatusKey(details))}
                </span>
              }
            />
            <DetailRow label="Message Type" value={details?.message_type} />
            <DetailRow label="Character Count" value={details?.character_count} />
            <DetailRow label="Segment Count" value={details?.segment_count} />
            <DetailRow label="Single Message Cost" value={details?.single_message_cost} />
            <DetailRow label="Estimated Cost" value={details?.estimated_cost} />
            <DetailRow label="Receiver Students" value={details?.receiver_student_count} />
            <DetailRow label="Receiver Parents" value={details?.receiver_parent_count} />
            <DetailRow label="Approval Time" value={formatDate(details?.approval_time)} />
            <DetailRow label="Approved From" value={details?.approved_from} />
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default MessagesApprovalDetailsModal;
